import * as React from "react";
import type { SVGProps } from "react";
const SvgInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <g
      stroke="#01579B"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path
        d="M12 21a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9"
        clipRule="evenodd"
      />
      <path d="M12 17v-5h-1M11.749 8a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5" />
    </g>
  </svg>
);
export default SvgInfo;
